import React, { useState } from "react";
import "./ImageUpload.css";
import "../modalGr/Modal.css";
import { connect } from "react-redux";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import { Button } from "semantic-ui-react";
import Confirm from "../common/Confirm_1";
import { closeModal } from "../../actions/modalAction";
import { MdClose } from "react-icons/md";
import { RiDeleteBin5Line } from "react-icons/ri";
import{ multipleImageURL} from "../configC/keys"

const ImageUpload = (props) => {
  const [files, setFiles] = useState([]);
  const [openObj, setOpen] = useState({ open: false, filename: "" });

  function clearState() {
    setFiles([]);
  }
  const filesizes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const InputChange = (e) => {
    // --For Multiple File Input
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
  };

  const DeleteSelectFile = () => {
    const result = files.filter((data) => data.name !== openObj.filename);
    setFiles(result);
    setOpen({ ...openObj, open: false, filename: "" });
  };

  const show = (filename) => {
    setOpen({ ...openObj, open: true, filename });
  };

  const handleCancel = () => setOpen({ ...openObj, open: false, filename: "" });
  //**********************************
  const checkIsAllowedType = (selectedFiles) => {
    return selectedFiles
      .map((file) => {
        const allowedTypes = [".jpg", ".jpeg", ".png", ".svg", ".webp", ".gif"];
        const fileExtension = file.name.split(".").pop().toLowerCase();
        return allowedTypes.includes(`.${fileExtension}`);
      })
      .some((item) => item === false);
  };
  const checkIsAllowedTypeSingleFile = (file) => {
    const allowedTypes = [".jpg", ".jpeg", ".png", ".svg", ".webp", ".gif"];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    return allowedTypes.includes(`.${fileExtension}`);
  };
  // ***

  const renderDeleteButton = (filename) => (
    <span onClick={() => show(filename)} className="ml-05">
      <RiDeleteBin5Line
        className="icon-gr"
        style={{ backgroundColor: "red" }}
      />
    </span>
  );
  //^^^^^^^^^^^
  // @@@
  const handleUploadImage = async (ev) => {
    ev.preventDefault();
    const imageURL = multipleImageURL;
// console.log('imageURL',imageURL)
    // if (files.length) {
    // adding files to the form data
    const formData = new FormData();
    formData.append("folder", 'prop');
    formData.append("id", props.id);
    [...files].forEach((file) => {
      /* Here we give the form name 'image'. this same name in the
           upload.array('image') middleware
        */
      formData.append("image", file);
    });
    const imgRoute = props.imgRoute;
    const apiRoute = props.apiRoute;
   
    try {
      const resImage = await axios.post(`${imageURL}/${imgRoute}`, formData);
      if (resImage.data.msg === "success") {
        const values = {
          action: "add",
          id: props.id,
          images: resImage.data.images,
        };

        const res = await axios.put(`${apiRoute}`, values);
        if (res.data.msg === "success") {
          props.handleRefresh()
          props.closeModal();
          toastr.success("Image Added Successfully");
        }
      }
    } catch (error) {
      console.log("error_imageadd", error);
      toastr.error("Oops", "Something went wrong.Please Try Again_addimage");
    }
  };
  // @@@
 
  return (
    <>
      <Confirm
      message={openObj.filename}
        open={openObj.open}
        onCancel={handleCancel}
        onConfirm={DeleteSelectFile}
      />
      <div className="fileupload-view">
        <div className="">
          <div className="col-md-6">
            <div className="card-image-upload mt-5">
              <div className="card-body" style={{ position: "relative" }}>
                <span
                  className="modal-close-btn color-black flex-center"
                  onClick={props.closeModal}
                >
                  <MdClose />
                </span>
                <div className="kb-data-box">
                  <div className="kb-modal-data-title">
                    <div className="kb-data-title">
                      <h3>Upload Images</h3>
                    </div>
                  </div>
                  <form onSubmit={handleUploadImage}>
                    {files.length < 1 && (
                      <div className="kb-file-upload">
                        <div className="file-upload-box">
                          <input
                            accept="image/jpeg, image/svg, image/webp, image/jpg, image/png, image/gif"
                            type="file"
                            id="fileupload"
                            className="file-upload-input"
                            onChange={InputChange}
                            multiple
                          />
                          <span>
                            Drag and drop or{" "}
                            <span className="file-link">Choose your files</span>
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="">
                      {files.map((data, index) => {
                        
                        const err = checkIsAllowedTypeSingleFile(data)
                          ? ""
                          : "Not an Image !";
                        
                        const filename = data.name;
                        
                        const fileimage = URL.createObjectURL(data);

                        return (
                          <div className="mb-20" key={index}>
                            <div className="file-image">
                              {" "}
                              <img src={fileimage} alt="" />
                            </div>
                            <div className=" flex-center nowrap">
                              <span>{filename}</span>
                              <span style={{ color: "red", fontWeight: "900" }}>
                                {err}
                              </span>

                              {renderDeleteButton(filename)}
                              
                              
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <p style={{ color: "red", fontWeight: "900" }}>
                      {checkIsAllowedType(files)
                        ? "Upload Images Only !  "
                        : ""}
                      {files.length > 5
                        ? "You can Upload 5 Images Only at a time !"
                        : ""}
                    </p>
                    <div className="kb-buttons-box">
                      <Button
                        disabled={
                          files.length < 1 ||
                          files.length > 5 ||
                          checkIsAllowedType(files)
                        }
                        type="submit"
                        className="btn btn-primary form-submit"
                      >
                        Upload
                      </Button>
                      <Button type="button" color="teal" onClick={clearState}>
                        cancell
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {images.map((file) => {
        return (
          <div>
            {" "}
            <img src={`http://192.168.2.47:5000/files/${file}`} alt="images" />
          </div>
        );
      })} */}
    </>
  );
};

export default connect(null, { closeModal })(ImageUpload);
